export default function LbiLogo({ size = 24, className = '' }) {
  return (
    <svg
      viewBox="25 180 272 228"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon fill="#569258" points="75.33 187 98.97 245.68 164.69 221.59 75.33 187"/>
      <polygon fill="#638082" points="248.56 190.85 164.69 221.59 226.01 245.32 248.56 190.85"/>
      <path fill="#49736b" d="M161.56,401.03L32.21,270.14l129.35,130.88ZM98.97,245.68l62.59,155.35,128.57-130.88-128.57,130.88,64.45-155.71-61.32-23.74-65.72,24.09Z"/>
      <polygon fill="#4c8652" points="32.21 270.15 98.97 245.68 75.33 186.99 32.21 270.15"/>
      <polygon fill="#416d63" points="32.21 270.15 161.56 401.03 98.97 245.68 32.21 270.15"/>
      <polygon fill="#3c515f" points="248.56 190.85 248.56 190.85 226.01 245.32 290.13 270.15 248.56 190.85"/>
      <polygon fill="#2e4c55" points="226.01 245.32 161.56 401.03 290.13 270.15 226.01 245.32"/>
    </svg>
  );
}
